module.exports = __webpack_public_path__ + "img/seminar6.5d8c36a7.jpg";